"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTLStorageItem = void 0;
var TTLStorageItem = (function () {
    function TTLStorageItem(storageItem, defaultTTL) {
        this.storageItem = storageItem;
        this.defaultTTL = defaultTTL;
        this.cachedEntry = null;
    }
    TTLStorageItem.prototype.get = function () {
        var cached = this.getCachedEntry();
        if (!cached) {
            return null;
        }
        var now = Date.now();
        if (now - cached.timestamp > cached.ttl) {
            this.remove();
            return null;
        }
        return cached.data;
    };
    TTLStorageItem.prototype.set = function (value, ttl) {
        var cached = {
            data: value,
            timestamp: Date.now(),
            ttl: ttl !== null && ttl !== void 0 ? ttl : this.defaultTTL,
        };
        this.cachedEntry = cached;
        try {
            this.storageItem.set(JSON.stringify(cached));
        }
        catch (_a) {
        }
    };
    TTLStorageItem.prototype.remove = function () {
        this.cachedEntry = null;
        this.storageItem.remove();
    };
    TTLStorageItem.prototype.getStale = function () {
        var _a;
        var cached = this.getCachedEntry();
        return (_a = cached === null || cached === void 0 ? void 0 : cached.data) !== null && _a !== void 0 ? _a : null;
    };
    TTLStorageItem.prototype.getCachedEntry = function () {
        if (this.cachedEntry) {
            return this.cachedEntry;
        }
        try {
            var stored = this.storageItem.get();
            if (stored) {
                var parsed = JSON.parse(stored);
                this.cachedEntry = parsed;
                return parsed;
            }
        }
        catch (_a) {
        }
        return null;
    };
    return TTLStorageItem;
}());
exports.TTLStorageItem = TTLStorageItem;
//# sourceMappingURL=ttl-storage-item.js.map